import { useSelector } from "react-redux";
import { RootState } from "src/context/store";

// M10-16144: only these roles get the invoice list loaded by default when they open the Entry /
// Approval screens. Every other role must search or apply a filter first, so opening the page
// doesn't fire an unfiltered /stockist_attachment/all request.
export const ROLES_WITH_DEFAULT_INVOICE_LIST = ["Management", "Invoice Entry", "Invoice Approval"];

export const INVOICE_SEARCH_PROMPT = "Search or apply filters to view invoices";

// True when any invoice filter holds a value: a non-empty array, a date range with a bound set,
// or a set scalar (fromTime / toTime).
export const hasActiveInvoiceFilters = (filters?: Record<string, any> | null) =>
  Object.values(filters ?? {}).some((value) => {
    if (Array.isArray(value)) return value.length > 0;
    if (value && typeof value === "object") return Boolean(value.from || value.to);
    return Boolean(value);
  });

const useInvoiceSearchGate = (filters?: Record<string, any> | null, searchValue?: string) => {
  const role = useSelector((state: RootState) => state.auth.idTokenDetails?.["custom:mv_role"]);
  console.log(role)
  const loadsByDefault = ROLES_WITH_DEFAULT_INVOICE_LIST.includes(role);
  console.log(loadsByDefault,"loadsByDefault")
  const hasCriteria = Boolean(searchValue?.trim()) || hasActiveInvoiceFilters(filters);

  return {
    // fetch the list now?
    canFetch: loadsByDefault || hasCriteria,
    // show the "search or filter" empty state instead of the list?
    awaitingCriteria: !loadsByDefault && !hasCriteria,
  };
};

export default useInvoiceSearchGate;
